

export let profile = [
    {
        key: "name", displayName: "Name", order: 1, type: "string",
        error: "", value: "", helperText: "", required: true,
    },
    {
        key: "email", displayName: "Email", order: 2, type: "string",
        error: "", value: "", helperText: "", required: true, disabled: true,
    }
];



